var map = {
	"./dingbeauty/reservation/pet-avatar-default@2x.png": "46c4",
	"./ipetbooking/reservation/pet-avatar-default@2x.png": "44bb",
	"./jtails/reservation/pet-avatar-default@2x.png": "f78c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "70ff";